// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { pause16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-pause': IconPause;
    }
}

/**
 * The icon component for the 'pause' icon
 */
export class IconPause extends IconSvg {
    public constructor() {
        super(pause16X16);
    }
}

registerIconSvg('icon-pause', IconPause);
export const iconPauseTag = 'nimble-icon-pause';
